import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { PaymentPlan } from "src/api/client-api/payment/usePaymentPlans";

export const useSubscriptionFormatting = (resolvedPlan: PaymentPlan | undefined) => {
    const { t, i18n } = useTranslation();

    const priceCents = typeof resolvedPlan?.priceInCents === "number" ? resolvedPlan.priceInCents : undefined;
    const currency = (resolvedPlan?.currency ?? "EUR").toUpperCase();
    const interval = resolvedPlan?.billingInterval ?? "year";

    const formattedAmount = useMemo(() => {
        const amountNumber = typeof priceCents === "number" ? priceCents / 100 : NaN;
        return Number.isFinite(amountNumber) ?
                new Intl.NumberFormat(i18n.language, { style: "currency", currency }).format(amountNumber)
            :   t("companySettings.subscription.amount_unknown", "N/A");
    }, [priceCents, currency, i18n.language, t]);

    const intervalLabel = useMemo(
        () =>
            interval === "month" ?
                t("companySettings.subscription.interval_month", "month")
            :   t("companySettings.subscription.interval_year", "year"),
        [interval, t],
    );

    return {
        formattedAmount,
        interval,
        intervalLabel,
        currency,
    };
};
